module.exports = __webpack_public_path__ + "static/img/dfe678e1923d3733b2eb718cb47b846.1a3f014.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dfe678e1923d3733b2eb718cb47b846.jpg
// module id = Lp2N
// module chunks = 4